import axios from "axios";


var Account = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },
    get: function () {
        return axios.get(
            Apollo.resolveApiUrl("~/member/"));
    },
    emulate: function (params) {
        return axios.post(Apollo.resolveApiUrl("~/emulate/"), params);
    },
    resetEmulation: function (params) {
        return axios.post(Apollo.resolveApiUrl("~/emulate/reset"), params);
    },
    getCurrentPerson: function () {
        return axios.get(
            Apollo.resolveApiUrl("~/person/me"));
    },
    getUser: function () {
        return axios.get(
            Apollo.resolveApiUrl("~/user/"));
    },
    getSessionId: function () {
        return axios.get(
            Apollo.resolveApiUrl("~/user/getSessionId"));
    },

    
};

export default Account;



// WEBPACK FOOTER //
// ./src/models/Account.js